<template>
  <div class="px-3">
    <!-- COUNTER:
    {{ $store.state.auth.counters["import_maps"] }} showDismissibleAlert:
    {{ showDismissibleAlert }} showDA: {{ showDA }} -->
    <!-- align-h="center" -->
    <b-row class="mt-1">
      <div class="col-md-12" data-error="dismissable-import-maps">
        <b-alert
          v-model="showDismissibleAlert"
          variant="danger"
          dismissible
          fade
        >
          ALCUNE FORME DI PAGAMENTO IMPORTATE NON SONO ANCORA MAPPATE, I VALORI
          DELLA CONTABILITA' POTREBBERO ESSERE INCOERENTI FINO ALLA MAPPATURA DI
          TUTTE LE FORME DI PAGAMENTO
        </b-alert>
      </div>
    </b-row>
    <!-- Azioni della home in alto a destra, come nelle altre pagine: un solo
         bottone primario (Crea attività). -->
    <div class="home-toolbar">
      <b-button
        variant="secondary"
        class="btn--transparent btn--smaller"
        size="sm"
        @click="$bvModal.show('birthdayRegistryModal')"
      >
        Compleanni
      </b-button>
      <b-dropdown
        v-if="canModule('module.HOME.LAPP')"
        right
        size="sm"
        toggle-class="btn--smaller btn--transparent"
        :disabled="isDownloading"
      >
        <template #button-content>
          <base-icon name="download" width="20" height="20" />
          Esporta Lisa4App
        </template>
        <b-dropdown-item-button
          v-for="file in lisaForAppFiles"
          :key="file.code"
          :disabled="hasLisaForAppPermission()"
          :title="
            !hasLisaForAppPermission() ? file.label : 'Funzione non abilitata'
          "
          @click="onDownload(file.code)"
        >
          {{ file.label }}
        </b-dropdown-item-button>
      </b-dropdown>
      <b-button
        class="btn btn-create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="createTask(1)"
        title="Crea una nuova attività"
        v-if="canVerb('tasks', 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        <span>Crea attività</span>
      </b-button>
    </div>
    <b-row class="home-row">
      <div class="col-md-7 p-0">
        <!-- Niente velo durante il caricamento: la griglia si vede subito e
             gli appuntamenti compaiono quando arrivano. -->
        <div class="ml-3 form-card-wrapper">
          <b-card class="calendar">
            <full-calendar
              ref="fullCalendar"
              :options="calendarOptions"
              class="fc"
            />
          </b-card>
        </div>
      </div>
      <!-- Colonna alta quanto il calendario, con scorrimento interno: le
           attività che arrivano non spostano nulla. -->
      <div class="col-md-5 home-tasks">
        <h5 class="home-tasks__title">
          Attività
          <span v-if="!tasksLoading || tasks.length" class="home-tasks__count">
            {{ tasks.length }}
          </span>
        </h5>
        <div class="home-tasks__scroll">
          <div
            v-if="tasksLoading && !tasks.length"
            class="home-tasks__grid"
            role="status"
          >
            <span class="sr-only">Operazione in corso...</span>
            <div
              v-for="n in 6"
              :key="n"
              class="task-card task-card--skeleton"
              :style="{ '--i': n }"
              aria-hidden="true"
            >
              <span class="task-skeleton" style="width: 70%; height: 12px"></span>
              <span class="task-skeleton" style="width: 90%"></span>
              <span class="task-skeleton" style="width: 55%"></span>
              <span class="task-card__footer">
                <span class="task-skeleton" style="width: 90px"></span>
                <span
                  class="task-skeleton"
                  style="width: 96px; height: 19px; border-radius: 10px"
                ></span>
              </span>
            </div>
          </div>
          <div v-else-if="tasks.length" class="home-tasks__grid">
            <div
              v-for="(task, index) in tasks"
              :key="index"
              class="task-card"
              role="button"
              tabindex="0"
              :title="`Visualizza Modifica dettagli ${task.title}`"
              @click="viewTask(task)"
              @keydown.enter.self="viewTask(task)"
            >
              <span class="task-card__title">{{ task.title }}</span>
              <span class="task-card__description">{{
                trimTaskDescription(task.description)
              }}</span>
              <span v-if="!isOwnTask(task)" class="task-card__owner">{{
                ownerInfo(task)
              }}</span>
              <span class="task-card__footer">
                <span class="task-card__dates">
                  <span
                    v-if="
                      task.expired_at !== null &&
                      task.status_task.text !== 'Completato'
                    "
                    class="task-card__due"
                    :class="`is-${setExpirationDateColor(task.expired_at)}`"
                    title="Scadenza"
                  >
                    <b-icon icon="alarm"></b-icon>
                    {{ correctDateFormat(task.expired_at)
                    }}{{ setExpiredLabel(task.expired_at) }}
                  </span>
                  <span
                    v-if="task.task_recurrence_id != null && !isSameDate(task)"
                    class="task-card__recurrence"
                    :title="`Ricorrenza ${getFrequencyOptionsLabel(
                      task.task_recurrence.type,
                    )} dal ${moment(task.ended_at).format(
                      'DD/MM/YYYY',
                    )} al ${moment(task.ended_at).format('DD/MM/YYYY')}`"
                  >
                    <b-icon icon="arrow-repeat"></b-icon>
                    {{ moment(task.ended_at).format("DD/MM/YYYY") }}
                  </span>
                </span>
                <span class="task-card__status">
                  <status-badge kind="task" :status="task.status_task" />
                  <span
                    v-if="
                      task.status_task.text === 'Completato' &&
                      isDeletable(task)
                    "
                    class="action-buttons"
                  >
                    <b-button
                      size="sm"
                      variant="lisaweb"
                      @click.stop="deleteEvent(task)"
                      class="btn--delete"
                      :title="`Elimina attività ${task.title}`"
                    >
                      <base-icon name="trash" width="19" height="19"></base-icon>
                    </b-button>
                  </span>
                </span>
              </span>
            </div>
          </div>
          <p v-else class="home-tasks__empty">Nessuna attività.</p>
        </div>
      </div>
    </b-row>
    <div v-if="formLoaded">
      <event-create-modal
        v-model="evt"
        :beFormCreate="beCreateForm['task']"
        :beRulesCreate="beRules['task']"
        @cancel="cancelEventCreation"
        @create="storeEvent"
      ></event-create-modal>
      <!-- :taskType="typ" -->

      <event-show-modal
        :selectInfo="inf"
        @delete="deleteEvent"
        @change="handleChangeClick"
      ></event-show-modal>
      <!-- :taskType="typ" -->
      <!-- :ref="changeModalRef" -->
      <event-change-modal
        v-model="evt"
        :beFormUpdate="beEditForm['task']"
        :beRulesUpdate="beRules['task']"
        @cancel="cancelEventChange"
        @update="customPutEvent"
      ></event-change-modal>
      <!-- :taskType="typ" -->
    </div>
    <!-- test shortcuts -->
    <!-- <b-row class="px-4">
      <div class="form-group col-md-2">
        <b-btn
          variant="lisaweb"
          class=""
          size="sm"
          @click="
            shortcut(
              'registries.edit',
              1,
              null,
              null,
              null,
              { /* fromShortcut: true */ },
              [
                {
                  text: 'Portafoglio',
                  path: '',
                  tab: '',
                  level: 0,
                  disabled: true,
                },
                {
                  text: 'Gestione Portafoglio',
                  path: 'module.PFOLIO',
                  tab: '',
                  level: 1,
                },
                {
                  text: 'Clienti',
                  path: 'module.PFOLIO',
                  tab: '#Registries',
                  level: 2,
                },
              ]
            )
          "
        >
          Mod. Cliente (id: 1)
        </b-btn>
      </div>
      <div class="form-group col-md-2">
        <b-btn
          variant="lisaweb"
          class=""
          size="sm"
          @click="
            shortcut('module.PFOLIO', null, '#Registries', 'filterRegistry', {
              'attributables.SURN': 'Fabbri',
            })
          "
        >
          Clienti (SURN: Fabbri)
        </b-btn>
      </div>
      <div class="form-group col-md-2">
        <b-btn
          variant="lisaweb"
          class=""
          size="sm"
          @click="shortcut('module.PFOLIO', null, '#Policies')"
        >
          Policies
        </b-btn>
      </div>
      <div class="form-group col-md-2">
        <b-btn
          variant="lisaweb"
          class=""
          size="sm"
          @click="
            shortcut(
              'module.PFOLIO',
              null,
              '#Registries',
              'filterRegistry',
              { id: 1 },
              {
                click: 'openModal',
                id: 1,
                modalName: 'modal',
                hash: '#General',
              }
            )
          "
        >
          Clienti tab Generale
        </b-btn>
      </div>
      <div class="form-group col-md-2">
        <b-btn
          variant="lisaweb"
          class=""
          size="sm"
          @click="
            shortcut(
              'module.PFOLIO',
              null,
              '#Policies',
              'filterPolicy',
              { id: 1 },
              {
                click: 'openModal',
                id: 1,
                modalName: 'modal',
                hash: '#Appointments',
              }
            )
          "
        >
          Polizze tab Appuntamenti
        </b-btn>
      </div>
      <div class="form-group col-md-2">
        <b-btn
          variant="lisaweb"
          class=""
          size="sm"
          @click="
            shortcut(
              'brokers.index0',
              null,
              null,
              'filterSalesmen',
              { id: 2 },
              {
                click: 'openModal',
                id: 2,
                modalName: 'modal',
                hash: '#Notes',
              }
            )
          "
        >
          Produttori tab Note
        </b-btn>
      </div>
      <div class="form-group col-md-2">
        <b-btn
          variant="lisaweb"
          class=""
          size="sm"
          @click="
            shortcut(
              'brokers.index1',
              null,
              null,
              'filterCooperaor',
              { id: 1 },
              {
                click: 'openModal',
                id: 1,
                modalName: 'modal',
                hash: '#Todo',
              }
            )
          "
        >
          Collaboratori tab Todo
        </b-btn>
      </div>
      <div class="form-group col-md-2">
        <b-btn
          variant="lisaweb"
          class=""
          size="sm"
          @click="shortcut('module.CONT.CONP', null, '#BrokerStatements')"
        >
          Contabilità produttori tab Storico rendiconti
        </b-btn>
      </div>
    </b-row> -->
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { mapGetters } from "vuex";
import moment from "moment";

moment.locale("it");

import FormMixin from "@/mixins/FormMixin";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import CalendarEventsAndTasksMixin from "@/mixins/CalendarEventsAndTasksMixin";
import StatusBadge from "@/components/StatusBadge";
// import ExportOptions from "@/components/ExportOptions";

export default {
  mixins: [ShortcutMixin, CalendarEventsAndTasksMixin, FormMixin],
  components: {
    BaseIcon,
    FullCalendar,
    StatusBadge,
  },
  data() {
    return {
      exportUrl: null,
      isDownloading: false,
      lisaForAppFiles: [
        { code: "PTRAAUTO", label: "Scarica File Unoone Polizze" },
        { code: "PTRAEXAU", label: "Scarica File Unoone Dati Tecnici" },
        { code: "PTRAVITA", label: "Scarica File Unoone Titoli" },
      ],
      showDismissibleAlert: false,
      calendarViewStartDate: null,
      calendarViewEndDate: null,
      lowerLimit: 6,
      upperLimit: 14,
      isExpired: false,
      // sampleTask: {
      //   id: 1,
      //   title: "event0",
      //   start: "2021-06-01T09:00:00",
      //   end: "2021-06-01T11:45:00",
      //   status_task: 2,
      //   description: "this is the description of event0",
      //   users: [1],
      //   owner_id: "luca@mail.com",
      //   taskable_id: "polizze",
      //   backgroundColor: "magenta",
      //   textColor: "white",
      // },
      formLoaded: false,
      formEditLoaded: false,
      tasksLoading: true,
      eventsLoading: true,
      resource: "tasks",
      repository: "task",
      tasks: [],
      form: {
        task: {
          id: null,
          title: null,
          description: null,
          task_type: null,
          status_task: null,
          expired_at: null,
          users: null,
          owner_id: null,
          //taskable: null, //nome della relazione
          //taskable_id: null, //array di ID di modelli (verosimilmente sempre 1 nelle ns. GUI)
          // need to handle date and time separated
          // started_at: null,
          // ended_at: null,
          start: null, // date
          end: null, // date
          startTime: null,
          endTime: null,
        },
        update_future_recurrence: true,
      },
      frequencyOptions: [
        { value: 0, text: "giornaliera" },
        { value: 7, text: "settimanale" },
        { value: 1, text: "mensile" },
        { value: 2, text: "bimestrale" },
        { value: 3, text: "trimestrale" },
        { value: 4, text: "quadrimestrale" },
        { value: 6, text: "semestrale" },
        { value: 12, text: "annuale" },
      ],
      beCreateForm: {}, // define this copy for co-existence of create an edit inside the same component
      beEditForm: {}, // define this copy for co-existence of create an edit inside the same component
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
        height: 600,
        showNonCurrentDates: true,
        // nextDayThreshold: "00:00:00",
        locale: "it",
        firstDay: 1,
        slotMinTime: "00:00:00",
        // Appuntamenti contemporanei uno di fianco all'altro: sovrapposti, il
        // testo di quello sotto si leggeva attraverso quello sopra.
        slotEventOverlap: false,
        slotMaxTime: "24:00:00",
        initialView: "timeGridWeek",
        noEventsText: "Nessun appuntamento da visualizzare",
        allDayText: "tutto il giorno",
        headerToolbar: {
          // start: 'title', // will normally be on the left. if RTL, will be on the right
          // center: '',
          // end: 'today prev,next' // will normally be on the right. if RTL, will be on the left
          // start: 'title',
          // center: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
          // right: 'prevYear,prev,next,nextYear'
          start: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
        },
        // titleFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        buttonText: {
          today: "oggi",
          month: "mese",
          week: "settimana",
          day: "giorno",
          list: "lista",
        },
        eventTextColor: "#000",
        // eventBorderColor: "#F9991E",
        // dateClick: this.handleDateClick,
        events: [],
        editable: true,
        selectable: true,
        selectMirror: true,
        eventResizableFromStart: true,
        eventClassNames: this.handleEventClassName,
        // eventClassNames: function (arg) {
        // if (arg.event.extendedProps?.owner_id == this?.$store?.state?.auth?.user?.id) {
        //   return ["event-from-owner"];
        // } else {
        //   return ["event-from-other"];
        // }
        // },
        allDayMaintainDuration: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        eventDrop: this.customHandleEventDrop,
        eventAllow: this.handleEventAllow,
        eventResize: this.customHandleEventResize,
        //https://fullcalendar.io/docs/datesSet
        datesSet: this.handleMonthChange,
        // you can update a remote database when these fire
        // eventAdd: this.handleAddEvent,
        // eventRemove: this.handleRemoveEvent,
        // eventChange: this.handleChangeEvent,
      },
      // this prevents label errors on modals when trying to draw labels for non-defined-by-api fields (eg. start, end, startTime, endTime)
      extendedBeForm: {
        // required to merge the beForm with defaults (eg when fetchCreateForm or fetchEditForm doesn provide certain fields)
        start: {
          label: "Data inizio evento",
        },
        end: {
          label: "Data fine evento",
        },
        startTime: {
          label: "Ora inizio evento",
        },
        endTime: {
          label: "Ora fine evento",
        },
      },
      // a component implementing the taskable must define them (HERE JUST FOR DEBUG)
      //taskable_id: [1], // would be the resourceId of the show/edit view of the model
      //taskable: "insurancePolicies", // would be the relation
      taskable_id: null,
      taskable: null,
    };
  },
  props: {
    // msg: String,
  },
  beforeMount() {
    this.fetchCreateForm(this.repository)
      .then(() => {
        // initialize also the EditForm to prevent errors: real info later in eventChange
        this.beCreateForm[this.repository] = this.beEditForm[this.repository] =
          this.convertDataToCalendarEvents([this.beForm[this.repository]])[0];
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
      })
      .finally(() => {
        this.formLoaded = true;
      });
  },
  mounted() {
    const queryString = `count&byImport=treasury&byAttribute[mappable_temp]=treasury`;
    let Repo = RepositoryFactory.get("import_map");
    Repo.get_unmapped(queryString)
      .then((response) => {
        // console.log("response: ", response);
        this.showDismissibleAlert = !!response?.data?.data?.count ?? false;
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
      });
    this.fetchEvents();
  },
  methods: {
    moment,
    getFrequencyOptionsLabel(id) {
      return this.frequencyOptions.find((el) => el.value === id).text;
    },
    isSameDate(task) {
      return moment(task.ended_at).isSame(task.task_recurrence.start_date);
    },
    customPutEvent(update_future_recurrence) {
      this.form.update_future_recurrence = update_future_recurrence;
      this.putEvent();
    },
    ...mapGetters("auth", {
      getLisaForAppsPermissions: "lisa_for_apps",
    }),
    ...mapGetters("auth", {
      getUsers: "users",
    }),
    customHandleEventDrop(draggedEvent) {
      this.eventsLoading = true;
      this.handleEventDrop(draggedEvent);
    },
    customHandleEventResize(eventResized) {
      this.eventsLoading = true;
      this.handleEventResize(eventResized);
    },
    hasLisaForAppPermission() {
      const permissions = this.getLisaForAppsPermissions();
      return Object.values(permissions).some(
        (permission) => permission?.can_extract?.value === "Y",
      )
        ? false
        : true;
    },
    isOwnTask(task) {
      return task?.owner_id == this?.$store?.state?.auth?.user?.id
        ? true
        : false;
    },
    ownerInfo(task) {
      return `Creato da: ${
        this.getUsers().find((user) => user.value === task?.owner_id)
          ?.username ?? "-"
      }`;
    },
    onDownload(code) {
      const Repo = RepositoryFactory.get("lisa_for_app");
      this.$showSnackbar({
        preset: "info",
        text: `Generazione in corso...`,
      });
      // let payload = {
      //   code,
      // };
      let payload = {
        extraction_type: null,
      };
      switch (code) {
        case "PTRAAUTO": // polizze
          payload.extraction_type = "polizze.txt";
          break;
        case "PTRAEXAU": // dati tecnici
          payload.extraction_type = "dettaglio_rca.txt";
          break;
        case "PTRAVITA": // titoli
          payload.extraction_type = "quietanze.txt";
          break;
        default:
          break;
      }
      this.isDownloading = true;
      Repo.report(payload)
        .then((response) => {
          this.$showSnackbar({
            preset: "success",
            text: "Download Iniziato",
          });
          const blob = new Blob([response.data], { type: response.data.type });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          // link.download = `${code}.${extension}`;
          link.download = `${payload.extraction_type}`;
          link.click();
          URL.revokeObjectURL(link.href);
          this.isDownloading = false;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isDownloading = false;
        });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Attività eliminata con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    convertDateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
    },
    correctDateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    setExpiredLabel(date) {
      const enteredDate = new Date(date).setHours(0, 0, 0, 0);
      const currentDate = new Date().setHours(0, 0, 0, 0);

      if (enteredDate < currentDate) {
        let showExpired = " (Scaduta)";
        return showExpired;
      }
      if (enteredDate == currentDate) {
        let showExpired = " (Ultimo giorno)";
        return showExpired;
      }
      return;
    },
    setExpirationDateColor(date) {
      let color = "";
      const enteredDate = new Date(date);
      const currentDate = new Date();

      if (enteredDate <= currentDate) {
        color = "red";
      } else if (currentDate > enteredDate.setDate(enteredDate.getDate() - 7)) {
        color = "orange";
      } else {
        color = "";
      }
      return color;
    },
    getDateMonth(date) {
      return moment(date, "YYYY-MM-DD").format("M");
    },
    calculateMonthRange(date) {
      // subtract lowerLimit days and add upperLimit days to the first and last day of the calendar view
      this.calendarViewStartDate = moment(date, "YYYY-MM-DD")
        .startOf("month")
        .subtract(this.lowerLimit, "d")
        .format("YYYY-MM-DD");
      this.calendarViewEndDate = moment(date, "YYYY-MM-DD")
        .endOf("month")
        .add(this.upperLimit, "d")
        .format("YYYY-MM-DD");
    },
    handleEventClassName(arg) {
      if (
        arg.event.extendedProps?.owner_id == this?.$store?.state?.auth?.user?.id
      ) {
        return ["event-from-owner"];
      } else {
        return ["event-from-other"];
      }
    },
    handleMonthChange(payload) {
      // call after the calendar’s date range has been initially set or changed in some way and the DOM has been updated.
      switch (payload.view.type) {
        case "dayGridMonth":
          if (
            // moment(moment(payload.start).format("YYYY-MM-DD")).isBefore(
            //   this.calendarViewStartDate
            // )
            moment(payload.start).isBefore(this.calendarViewStartDate)
          ) {
            // 1st day of month
            if (moment(payload.start).format("DD") == "01") {
              this.calculateMonthRange(
                moment(payload.start).format("YYYY-MM-DD"),
              );
            } else {
              this.calculateMonthRange(
                moment(payload.start).add(1, "months").format("YYYY-MM-DD"),
              );
            }
            this.fetchEvents(true, false);
            break;
          }
          if (
            // moment(
            //   moment(payload.end).subtract(1, "d").format("YYYY-MM-DD")
            // ).isAfter(this.calendarViewEndDate)
            moment(payload.end)
              .subtract(1, "d")
              .isAfter(this.calendarViewEndDate)
          ) {
            // not 28, 29, 30, 31 (last days of month)
            if (parseInt(moment(payload.end).format("DD")) <= this.upperLimit) {
              this.calculateMonthRange(
                moment(payload.end).subtract(1, "months").format("YYYY-MM-DD"),
              );
            } else {
              this.calculateMonthRange(
                moment(payload.end).format("YYYY-MM-DD"),
              );
            }
            this.fetchEvents(true, false);
          }
          break;
        case "timeGridDay":
        case "timeGridWeek":
        case "listWeek":
          if (
            // moment(moment(payload.start).format("YYYY-MM-DD")).isBefore(
            //   this.calendarViewStartDate
            // )
            moment(payload.start).isBefore(this.calendarViewStartDate)
          ) {
            this.calculateMonthRange(
              moment(payload.start).format("YYYY-MM-DD"),
            );
            this.fetchEvents(true, false);
          }
          if (
            // moment(
            //   moment(payload.end).subtract(1, "d").format("YYYY-MM-DD")
            // ).isAfter(this.calendarViewEndDate)
            moment(payload.end)
              .subtract(1, "d")
              .isAfter(this.calendarViewEndDate)
          ) {
            this.calculateMonthRange(moment(payload.end).format("YYYY-MM-DD"));
            this.rangeChanged = true;
            this.fetchEvents();
          }
          break;
      }
    },
    async loadTasks() {
      const Repo = RepositoryFactory.get("task");
      let queryString = `perPage=0&byAttribute[task_type]=1`;
      return await Repo.index(queryString)
        .then((response) => {
          let data = response.data.data;
          // let fetchedTasks = data
          return data
            .map((obj) => this.setClassNames(obj))
            .map((obj) => this.setAllDay(obj));
          // return this.convertDataToCalendarEvents(fetchedTasks);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          return [];
        });
    },
    async loadEvents() {
      const Repo = RepositoryFactory.get("task");
      let queryString = `perPage=0&byAttribute[task_type]=0&byCalendar=${this.calendarViewStartDate},${this.calendarViewEndDate}`;
      return await Repo.index(queryString)
        .then((response) => {
          let data = response.data.data;
          let fetchedEvents = data
            .map((obj) => this.setClassNames(obj))
            .map((obj) => this.setDraggable(obj))
            .map((obj) => this.setAllDay(obj));
          // .map((obj) => this.toCalAllDay(obj));
          return this.convertDataToCalendarEvents(fetchedEvents);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          return [];
        });
    },
    fetchEvents(events = true, tasks = true) {
      let info = this.getCalendarViewActiveStart();
      if (!this.calendarViewEndDate && !this.calendarViewEndDate) {
        this.calculateMonthRange(`${info.year}-${info.month}-${info.day}`);
      }
      if (events) {
        this.eventsLoading = true;
        this.loadEvents().then((data) => {
          this.calendarOptions.events = data;
          this.eventsLoading = false;
          this.fromCalendar = true;
        });
      }
      if (tasks) {
        this.tasksLoading = true;
        this.loadTasks().then((data) => {
          this.tasks = data;
          if (this.tasks.length) {
            const statusOrder = [
              "In lavorazione",
              "In attesa",
              "Da iniziare",
              "Completato",
            ];
            this.tasks = this.tasks.sort((a, b) => {
              return (
                statusOrder.indexOf(a.status_task.text) -
                statusOrder.indexOf(b.status_task.text)
              );
            });
          }
          this.tasksLoading = false;
          this.fromCalendar = true;
        });
      }
    },
    trimTaskDescription(desc) {
      if (desc) {
        if (desc.length < 100) return desc;
        return `${desc.slice(0, 100)}...`;
      }
      return desc;
    },
    isDeletable(task) {
      return task.owner_id == this?.$store?.state?.auth?.user?.id
        ? true
        : false;
    },
  },
  computed: {
    showDA() {
      return this.$store.state.auth.counters["import_maps"] != 0;
    },
  },
};
</script>
<style scoped lang="scss">
.task {
  margin-right: 0px !important;
  margin-left: 0px !important;
  min-height: 240px;
}

:deep(.fc) {
  // Colonna di oggi in azzurrino (era gialla) e griglia più leggera.
  --fc-today-bg-color: rgba(var(--lisaweb-rgb), 0.06);
  --fc-border-color: var(--gray-200);

  .fc-col-header-cell.fc-day-today {
    background: rgba(var(--lisaweb-rgb), 0.06);
  }

  .fc-timegrid-slot-minor {
    border-top-style: dashed;
    border-top-color: var(--gray-100);
  }

  // Bottoni come i secondari dell'app; la vista attiva nel colore del brand.
  // "oggi" disabilitato (oggi è già in vista) non sembra spento.
  .fc-button-primary,
  .fc-button-primary:disabled,
  .fc-button-primary:not(:disabled) {
    background: white;
    border: 1px solid var(--secondary-border);
    border-radius: var(--radius-sm);
    color: var(--color-text);
    font-weight: 400;
    opacity: 1;
    box-shadow: none;
  }

  .fc-button-primary:not(:disabled):hover {
    border-color: var(--secondary-border-hover);
  }

  .fc-button-primary:disabled {
    pointer-events: none;
    cursor: default;
  }

  .fc-button-primary.fc-button-active,
  .fc-button-primary:not(:disabled).fc-button-active {
    background: var(--lisaweb);
    border-color: var(--lisaweb);
    color: white;
  }

  .fc-button-group > .fc-button:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .fc-button-group > .fc-button:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .fc-today-button {
    margin-left: 8px;
  }

  /* overall text color (day name, day number, date) */
  /* .fc-event-title, .fc-event-time, .fc-daygrid-day-number, .fc-col-header-cell-cushion {
    color: #2C3E50
  } */
  a {
    color: #2c3e50;

    .fc-event-main {
      &,
      * {
        color: white;
      }
    }
  }
}

/* event && task CSS */
/* :deep(.task-expiring) {
  border-color: red !important;
  border: 3px solid;
} */

/* task cards */
// :deep(.card-title) {
// font-size: 0.9em;
// }

// :deep(.card-header) {
// font-size: 0.9em !important;
/* font-shadow: 2px 2px #00ff00; */
// }

// :deep(.card-text) {
// font-size: 0.9em;
/* font-shadow: 2px 2px #00ff00; */
// }

.modal-title {
  width: 100%;

  & > span {
    color: #f3f0ea;
    font-weight: bold;
    padding: 0 0.5rem;
  }
}

ul {
  list-style-type: none;
}

.calendar {
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background-color: #fff;
}

// .btn {
//   text-transform: uppercase;
//   font-weight: bold;
// }

:deep(.fc-header-toolbar > .fc-toolbar-chunk:first-of-type),
:deep(.fc-header-toolbar > .fc-toolbar-chunk:last-of-type) {
  min-width: 250px;
}

:deep(.fc-header-toolbar > .fc-toolbar-chunk:last-of-type .fc-button-group) {
  display: flex;
  justify-content: flex-end;
}

:deep(.fc-header-toolbar > .fc-toolbar-chunk:last-of-type) {
  text-align: right;
  //margin-right: 110px;
}

:deep(.fc-view-harness-active .fc-col-header-cell-cushion) {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-text-muted);
}

// Intestazioni dei giorni come quelle delle tabelle; oggi nel colore del
// brand.
:deep(.fc .fc-col-header-cell) {
  height: 36px;
  vertical-align: middle;
  background: #fff;
}

:deep(.fc .fc-col-header-cell.fc-day-today .fc-col-header-cell-cushion) {
  color: var(--lisaweb);
}

:deep(.fc .fc-timegrid-slot-label-cushion),
:deep(.fc .fc-timegrid-axis-cushion) {
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
}

:deep(.fc .fc-toolbar-title) {
  font-size: var(--font-size-lg);
  font-weight: 600;
}

// Vista (mese, settimana, giorno, lista) come le schede delle pagine:
// testo semplice, la scelta sottolineata nel colore del brand.
:deep(.fc .fc-toolbar-chunk:last-of-type .fc-button-group) {
  gap: 4px;
}

:deep(.fc .fc-toolbar-chunk:last-of-type .fc-button.fc-button-primary) {
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  padding: 6px 10px;

  // niente riquadro dopo il clic; resta per chi usa la tastiera
  &:focus:not(:focus-visible) {
    box-shadow: none;
  }
}

:deep(
    .fc .fc-toolbar-chunk:last-of-type .fc-button.fc-button-primary.fc-button-active
  ) {
  color: var(--lisaweb);
  background: transparent;
  border-bottom-color: var(--lisaweb);
}

:deep(.fc .fc-timegrid-axis-cushion) {
  text-align: right;
}

:deep(.fc-scrollgrid thead .fc-scroller) {
  overflow: hidden !important;
}

:deep(.fc-scrollgrid tbody tr:first-child .fc-scroller) {
  overflow: hidden !important;
}

:deep(.fc .fc-daygrid-body-natural .fc-daygrid-day-events .fc-timegrid-slot) {
  background-color: white !important;
}

:deep(.calendar .event-from-other),
:deep(.calendar .event-from-owner) {
  // Sfondo pieno (non trasparente): due eventi vicini non si confondono.
  background: color-mix(in srgb, var(--lisaweb) 14%, white);
  border: 0;
  border-left: 3px solid var(--lisaweb);
  border-radius: var(--radius-sm);
  box-shadow: none;
}

// Eventi brevi (bassi meno di 30px, es. un quarto d'ora): orario e titolo su una riga e,
// con due eventi affiancati, si vedeva solo l'orario. L'orario si legge già
// dalla posizione nella griglia: resta il titolo.
:deep(.calendar .fc-timegrid-event-short .fc-event-time) {
  display: none;
}

:deep(.calendar .event-from-other .fc-event-main),
:deep(.calendar .event-from-owner .fc-event-main),
:deep(.calendar .event-from-other .fc-event-main *),
:deep(.calendar .event-from-owner .fc-event-main *) {
  color: var(--status-open);
  font-weight: 600;
}

:deep(.fc-list-empty) {
  background-color: var(--gray-100) !important;
}

:deep(.calendar .fc-list-event-title),
:deep(.calendar .fc-list-event-title a) {
  color: var(--status-open);
}

:deep(.calendar .event-from-other .fc-list-event-dot),
:deep(.calendar .event-from-other .fc-daygrid-event-dot) {
  border-color: #ffbb00;
}

:deep(.calendar .event-from-owner .fc-list-event-dot),
:deep(.calendar .event-from-owner .fc-daygrid-event-dot) {
  border-color: #ffbb00;
}

:deep(.fc .fc-list-event.event-from-other:hover td),
:deep(.fc .fc-list-event.event-from-owner:hover td) {
  background: rgba(var(--lisaweb-rgb), 0.22);
  cursor: pointer;
}

:deep(.alert-dismissible .close) {
  padding: 0.4rem 1.25rem;
  top: 0;
  right: 0;
  line-height: 1;
}

.home-toolbar {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin: 8px 0 14px;
}

// Le due colonne alte uguali: la colonna attività prende l'altezza del
// calendario e scorre al suo interno.
.home-row {
  align-items: stretch;
}

.home-tasks {
  display: flex;
  flex-direction: column;
}

.home-tasks__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: var(--font-size-lg);
  font-weight: 600;
}

.home-tasks__count {
  padding: 1px 7px;
  font-size: var(--font-size-xs);
  font-weight: 600;
  color: #fff;
  background: var(--lisaweb);
  border-radius: var(--radius-pill);
}

.home-tasks__scroll {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

// Colonne una sotto l'altra (md del progetto: 789px): altezza propria.
@media (max-width: 788.98px) {
  .home-tasks__scroll {
    flex: none;
    max-height: 600px;
  }
}

.home-tasks__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

// Colonna stretta (fino a 1200px la colonna attività è sotto i 500px): una
// scheda per riga.
@media (max-width: 1199.98px) {
  .home-tasks__grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

.home-tasks__empty {
  color: var(--color-text-muted);
}

// Schede tutte alte uguali: due righe di descrizione, in fondo scadenza e
// stato.
.task-card {
  display: flex;
  flex-direction: column;
  height: 150px;
  overflow: hidden;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  cursor: pointer;

  &:not(.task-card--skeleton):hover,
  &:focus {
    border-color: var(--lisaweb);
    outline: 0;
  }
}

.task-card__title {
  overflow: hidden;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.task-card__description {
  display: -webkit-box;
  margin-top: 4px;
  overflow: hidden;
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.task-card__owner {
  margin-top: 4px;
  overflow: hidden;
  font-size: var(--font-size-sm);
  font-style: italic;
  color: var(--color-text-muted);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.task-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: auto;
}

.task-card__dates {
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
}

.task-card__due {
  &.is-orange {
    color: var(--status-wait);
  }

  &.is-red {
    font-weight: 600;
    color: var(--color-danger-strong);
  }
}

.task-card__status {
  display: flex;
  flex: none;
  align-items: center;
  gap: 6px;
}

// Segnaposto durante il caricamento, alla misura delle schede vere e con
// la stessa onda delle tabelle (TableSkeleton).
.task-card--skeleton {
  gap: 8px;
  cursor: default;
}

.task-skeleton {
  display: block;
  height: 10px;
  border-radius: 5px;
  background: rgba(17, 24, 28, 0.14);
  animation: task-skeleton-pulse 1.6s ease-in-out infinite;
  animation-delay: calc(var(--i, 0) * 90ms);
}

@keyframes task-skeleton-pulse {
  0%,
  100% {
    opacity: 0.55;
  }

  40% {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .task-skeleton {
    animation: none;
  }
}
</style>
